const urlConfig = {
    root: window.location.origin,
    services: ['/horsebook', '/voron', '/LimboBot', '/vrchat', "/HorseVet"]
};

export const URL_BACKEND = 'https://request.denishik.ru';

export default urlConfig